export const profile = {
  name: 'Kyle Speer',
  role: 'Software Engineer',
  tagline: 'An experienced software engineer passionate about DevOps and woodworking.',
  location: 'Marlton, NJ',
  email: 'kyle.d.speer@gmail.com',
  linkedin: 'https://www.linkedin.com/in/kyle-d-speer',
  github: 'https://github.com/kspeer825',
  about: [
    'I am a software engineer from New Jersey. I have worked as a Cloud Infrastructure Engineer, DevOps Engineer, and QA Engineer in the data, cable, and healthcare domains. I have experience building cloud infrastructure on AWS and Azure, CI/CD pipelines, data streaming services, and test automation frameworks.',
    'I graduated from the University of Pittsburgh with a B.S. in Physics and a minor in Computer Science.',
    'Outside of work I enjoy woodworking, hiking, and skiing.',
  ],
};
